import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiRequest } from '@app/packages/api/v2/types/entities'
import type { ApiDataResponse, ApiRequestMetaData } from '@app/packages/api/v2/types/misc'
import type { GetRequestsQuery, RequestCancelRequest, RequestRejectRequest, TrustedOrderRequest } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getRequests = (query: GetRequestsQuery) =>
  createApiAction('getRequests', dispatch =>
    dispatch<ApiDataResponse<ApiRequest[]> & { meta: ApiRequestMetaData }>({ method: 'GET', endpoint: v2Path('/api/v2/requests', query) })
  )

export const getRequestsById = (id: string) =>
  createApiAction('getRequestsById', dispatch => dispatch<ApiDataResponse<ApiRequest>>({ method: 'GET', endpoint: urlEscaped`/api/v2/requests/${id}` }))

export const postRequests = (announcement_response_id: string) =>
  createApiAction('postRequests', dispatch =>
    dispatch<ApiDataResponse<ApiRequest>>({ method: 'POST', endpoint: '/api/v2/requests', body: JSON.stringify({ announcement_response_id }) })
  )

export const putRequestsAccept = (request_id: string) =>
  createApiAction('putRequestsAccept', dispatch =>
    dispatch<ApiDataResponse<ApiRequest>>({ method: 'PUT', endpoint: urlEscaped`/api/v2/requests/${request_id}/accept` })
  )

export const putRequestsDecline = (request_id: string) =>
  createApiAction('putRequestsDecline', dispatch =>
    dispatch<ApiDataResponse<ApiRequest>>({ method: 'PUT', endpoint: urlEscaped`/api/v2/requests/${request_id}/decline` })
  )

export const putRequestsCancel = (request_id: string, request: RequestCancelRequest) =>
  createApiAction('putRequestsCancel', dispatch =>
    dispatch<ApiDataResponse<ApiRequest>>({
      method: 'PUT',
      endpoint: urlEscaped`/api/v2/requests/${request_id}/cancel`,
      body: JSON.stringify(request),
    })
  )

export const putRequestsReject = (request_id: string, request: RequestRejectRequest) =>
  createApiAction('putRequestsReject', dispatch =>
    dispatch<ApiDataResponse<ApiRequest>>({
      method: 'PUT',
      endpoint: urlEscaped`/api/v2/requests/${request_id}/reject`,
      body: JSON.stringify(request),
    })
  )

export const getRequestsWithDebt = () =>
  createApiAction('getRequestsWithDebt', dispatch => dispatch<ApiDataResponse<ApiRequest[]>>({ method: 'GET', endpoint: '/api/v2/requests/with_debt' }))

export const postRequestsWithDebtRepay = () =>
  createApiAction('postRequestsWithDebtRepay', dispatch => dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/requests/with_debt/repay' }))

/** Creates a trusted request: the parent asks a sitter they already trust. */
export const postRequestsByParentId = (parent_id: string, request: TrustedOrderRequest) =>
  createApiAction('postRequestsByParentId', dispatch =>
    dispatch<undefined>({ method: 'POST', endpoint: urlEscaped`/api/v2/requests/${parent_id}`, body: JSON.stringify(request) })
  )

export const putRequestsStart = (id: string) =>
  createApiAction('putRequestsStart', dispatch => dispatch<ApiDataResponse<ApiRequest>>({ method: 'PUT', endpoint: urlEscaped`/api/v2/requests/${id}/start` }))

export const putRequestsComplete = (id: string) =>
  createApiAction('putRequestsComplete', dispatch =>
    dispatch<ApiDataResponse<ApiRequest>>({ method: 'PUT', endpoint: urlEscaped`/api/v2/requests/${id}/complete` })
  )
